import React, { useState } from "react";

import { ToastContainer, toast } from "react-toastify";

import "react-toastify/dist/ReactToastify.css";

import DocMinter from "../DocMinter.json";

import QRCode from "react-qr-code";
import { Link } from "react-router-dom";

const Verify = () => {
  const ethers = require("ethers");

  const [fileId, setFileId] = useState(null);
  const [fileName, setFileName] = useState("");
  const [CIN, setCIN] = useState("");
  const [gender, setGender] = useState("");
  const [mintDate, setMintDate] = useState("");
  const [matchCIN, setMatchCIN] = useState(false);
  const [fileExist, setFileExist] = useState(false);
  const [fileURL, setFileURL] = useState("");
  const [fileOwner, setFileOwner] = useState("");
  const [fileStatus, setFileStatus] = useState("");

  function handleFileId(e) {
    console.log(e.target.value);
    setFileId(e.target.value);
  }

  function handleCIN(e) {
    console.log(e.target.value);
    setCIN(e.target.value);
  }

  async function fileVerify(e) {
    e.preventDefault();
    try {
      const alchemyProvider = new ethers.providers.AlchemyProvider(
        "maticmum",
        "mrvXire3FFkkoWo_HFHsBmRpJDRh1snd"
      );

      const signer = new ethers.Wallet(
        "794544ea59d049cc26fd0607233516895afec782c05f13cf30c9c025b7f8591e",
        alchemyProvider
      );

      let contract = new ethers.Contract(
        DocMinter.address,
        DocMinter.abi,
        signer
      );

      // verfiying the existence of the file
      let response = await contract.exist(fileId);

      console.log(response);

      if (response) {
        setFileExist(response);
        let fileDetails = await contract.getTokenInfo(fileId);
        console.log(fileDetails);
        if (CIN === fileDetails._userCIN) {
          setMatchCIN(response);
          setFileName(fileDetails._fileDocName);
          setFileURL(fileDetails._fileURL);
          setMintDate(fileDetails._mintDate);
          setGender(fileDetails._gender);
          setFileOwner(fileDetails._ownerOfNft);
          toast("File exists on blockchain!", { type: "success" });
        } else {
          toast("Please check your CIN", { type: "warning" });
        }
      } else {
        setFileStatus("File not minted into blockchain");
        toast("File does not exist in blockchain!", { type: "error" });
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className="verifyPage">
      <div className="verify_page_content">
        <ToastContainer />

        <h1>Verify document</h1>
        <h2>Please, if you want to verify a document/file refresh the page</h2>
        <form>
          <label htmlFor="fileId">File identifier : </label>
          <input
            type="number"
            id="fileId"
            name="firstname"
            placeholder="Enter the file Id"
            onChange={handleFileId}
            required
          />
          <label htmlFor="fileId">CIN : </label>
          <input
            type="text"
            id="fileId"
            name="firstname"
            placeholder="Enter the CIN"
            onChange={handleCIN}
            required
          />
          <button className="recovery">
            <Link to="/recovery" className="recovery_button">
              Contact university
            </Link>
          </button>{" "}
          <br />
          <br />
          <label htmlFor="verifyFile">
            <input
              id="verifyFile"
              className="verify"
              type="button"
              value="Verify file"
              onClick={fileVerify}
            />
          </label>
        </form>

        <div>
          {fileExist && matchCIN ? (
            <span>
              {fileName} with id {fileId} exists in blockchain <br />
              The minter -owner- of file {fileId} is {fileOwner}
              <br />
              File with Id {fileId} is minted in blockchain for this CIN number{" "}
              {CIN} {gender} <br /> Minted on : {mintDate} <br />
              <a href={fileURL} target="_blank">
                Click here to download the file
              </a>
              <br />
              <p>
                Or scan the QR code
                <br /> <QRCode value={fileURL} size={200} />
              </p>
            </span>
          ) : (
            <span></span>
          )}
        </div>
        <div></div>
      </div>
    </div>
  );
};

export default Verify;
